import { Component, OnInit, Input } from '@angular/core';
import { EncuestaCovidPreguntaDetalleEntity } from '../../../../services/servicio-encuesta-covid.service';

@Component({
  selector: 'app-seleccion-unica',
  templateUrl: './seleccion-unica.component.html',
  styleUrls: ['./seleccion-unica.component.css']
})
export class SeleccionUnicaComponent implements OnInit {

  value: number;

  @Input() public pregunta: EncuestaCovidPreguntaDetalleEntity;

  constructor() { }

  ngOnInit() {  
    if(this.pregunta && this.pregunta.resultado){
      this.value = Number(this.pregunta.resultado.resultado);
    }
  }

  getName() {
    return `grupo_${this.pregunta.id}`;
  }

  isChecked(p: any){
    return p.id === this.value;
  }

}
